import * as storage from "./storage";

export interface Settings {
  gridLines?: boolean;
  axisLabels?: boolean;
  toolShadow?: boolean;
  leftHanded?: boolean;
  thumbnailLarge?: boolean;
  thumbnailMedium?: boolean;
  thumbnailSmall?: boolean;
  transparentFill?: "black" | "white";
  resolution?: number;
}

const settingsKey = "settings";

export async function read(): Promise<Settings> {
  const settings = await storage.read<Settings>(settingsKey);
  if (settings) return settings;

  const defaults = {
    gridLines: true,
    axisLabels: true,
    toolShadow: true,
    leftHanded: false,
    thumbnailLarge: true,
    thumbnailMedium: true,
    thumbnailSmall: true,
    transparentFill: undefined,
    resolution: 256,
  };
  write(defaults);
  return defaults;
}

export function write(settings: Settings): void {
  storage.write(settingsKey, settings);
}
